export const TABS = {
  imports: 'imports',
  templates: 'templates',
  glossary: 'glossary',
} as const;
